import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Grid,
  IconButton,
  Chip,
  FormControl,
  InputLabel,
  Select,
  Alert,
  Toolbar,
  AppBar,
  Tabs,
  Tab,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Badge,
  Stack,
  InputAdornment,
  Link,
  Snackbar
} from '@mui/material';
import {
  Add,
  Edit,
  Delete,
  Assignment,
  FilterList,
  Person,
  Dashboard,
  Notifications,
  AccountCircle,
  Search,
  Visibility,
  Description,
  AttachFile,
  Schedule,
  CalendarToday,
  AccessTime,
  Notes,
  AssignmentTurnedIn,
  WatchLater,
  PictureAsPdf,
  Image,
  VideoFile,
  AudioFile,
  Download,
  OpenInNew,
  InsertDriveFile
} from '@mui/icons-material';
import { IonPage } from '@ionic/react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

// Your existing configuration
import { baseUrl, config, requestID } from '../../../common/utils';
 

const AdminTaskManagement = () => {
  const location = useLocation();
  const [urlIDx, setUrlIDx] = useState('');
  const [staffList, setStaffList] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [userActivities, setUserActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const [openDialog, setOpenDialog] = useState(false);
  const [assignDialog, setAssignDialog] = useState(false);
  const [viewDialog, setViewDialog] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [filters, setFilters] = useState({
    date: '',
    staff: '',
    type: 'all'
  });
  const [tabValue, setTabValue] = useState(0);

  const [newTask, setNewTask] = useState({
    title: '',
    description: '',
    dueDate: '',
    priority: 'medium',
    status: 'pending'
  });

  const [selectedStaff, setSelectedStaff] = useState([]);

  // Get URL ID from location
  useEffect(() => {
    const urlID = location.pathname.split("/").pop();
    setUrlIDx(urlID);
  }, [location]);

  // Fetch all data on component mount
  useEffect(() => {
    if (urlIDx) {
      fetchAllData();
    }
  }, [urlIDx]);

  // API Service Functions using FormData
  const apiService = {
    // Fetch staff list
    async fetchStaffList() {
      const formData = new FormData();
      formData.append("requestID", requestID());
 
      try {
        const response = await axios.post(
          baseUrl() + "businesss/getAllStaffs2",
          formData,
          config
        );
        console.log("Staff response:", response);
        return Array.isArray(response.data.data) ? response.data.data : [];
      } catch (error) {
        console.error("Error fetching staff:", error);
        throw error;
      }
    },

    // Fetch tasks
    async fetchTasks() {
      const formData = new FormData();
      formData.append("requestID", requestID());
 
      try {
        const response = await axios.post(
          baseUrl() + "TaskMonitors/getTasks",
          formData,
          config
        );
        console.log("Tasks response:", response);
        return Array.isArray(response.data.data) ? response.data.data : [];
      } catch (error) {
        console.error("Error fetching tasks:", error);
        throw error;
      }
    },

    // Fetch user activities
    async fetchUserActivities() {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", urlIDx);

      try {
        const response = await axios.post(
          baseUrl() + "user-activities/getUserActivities",
          formData,
          config
        );
        console.log("User activities response:", response);
        return Array.isArray(response.data.data) ? response.data.data : [];
      } catch (error) {
        console.error("Error fetching user activities:", error);
        throw error;
      }
    },

    // Create task
    async createTask(taskData) {
      const formData = new FormData();
      formData.append("requestID", requestID());
       
      // Append all task fields
      Object.keys(taskData).forEach(key => {
        if (Array.isArray(taskData[key])) {
          formData.append(key, JSON.stringify(taskData[key]));
        } else {
          formData.append(key, taskData[key]);
        }
      });

      try {
        const response = await axios.post(
          baseUrl() + "TaskMonitors/createTask",
          formData,
          config
        );
        console.log("Create task response:", response);
        return response.data.data;
      } catch (error) {
        console.error("Error creating task:", error);
        throw error;
      }
    },

    // Assign task to users
    async assignTask(taskId, assignedStaff) {
      const formData = new FormData();
      formData.append("requestID", requestID());
       formData.append("task_id", taskId);
      formData.append("assigned_staff", JSON.stringify(assignedStaff));

      try {
        const response = await axios.post(
          baseUrl() + "TaskMonitors/assignTask",
          formData,
          config
        );
        console.log("Assign task response:", response);
        return response.data.data;
      } catch (error) {
        console.error("Error assigning task:", error);
        throw error;
      }
    },

    // Delete task
    async deleteTask(taskId) {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", urlIDx);
      formData.append("task_id", taskId);

      try {
        const response = await axios.post(
          baseUrl() + "TaskMonitors/deleteTask",
          formData,
          config
        );
        console.log("Delete task response:", response);
        return response.data;
      } catch (error) {
        console.error("Error deleting task:", error);
        throw error;
      }
    },

    // Delete user activity
    async deleteUserActivity(activityId) {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", urlIDx);
      formData.append("activity_id", activityId);

      try {
        const response = await axios.post(
          baseUrl() + "user-activities/deleteUserActivity",
          formData,
          config
        );
        console.log("Delete activity response:", response);
        return response.data;
      } catch (error) {
        console.error("Error deleting activity:", error);
        throw error;
      }
    }
  };

  const fetchAllData = async () => {
    try {
      setLoading(true);
      const [staffData, tasksData , activitiesData] = await Promise.all([
        apiService.fetchStaffList(),
        apiService.fetchTasks(),
        apiService.fetchUserActivities()
      ]);

      setStaffList(staffData || []);
      setTasks(tasksData || []);
      setUserActivities(activitiesData || []);
      setError('');
    } catch (err) {
      setError('Failed to load data. Please try again.');
      showSnackbar('Failed to load data', 'error');
    } finally {
      setLoading(false);
    }
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Filter tasks based on filters
  const filteredTasks = tasks.filter(task => {
    const matchesDate = !filters.date || task.dueDate === filters.date;
    const matchesStaff = !filters.staff || task.assignedTo.includes(parseInt(filters.staff));
    const matchesType = filters.type === 'all' || filters.type === 'admin';
    return matchesDate && matchesStaff && matchesType;
  });

  const filteredActivities = userActivities.filter(activity => {
    const matchesDate = !filters.date || activity.dateSubmitted === filters.date;
    const matchesStaff = !filters.staff || activity.staffId === filters.staff;
    const matchesType = filters.type === 'all' || filters.type === 'user';
    return matchesDate && matchesStaff && matchesType;
  });

  const handleCreateTask = async () => {
    try {
      const taskData = {
        ...newTask,
        assignedTo: selectedStaff,
        createdAt: new Date().toISOString().split('T')[0],
        type: 'admin'
      };

      const createdTask = await apiService.createTask(taskData);
      setTasks([...tasks, createdTask]);
      
      setNewTask({
        title: '',
        description: '',
        dueDate: '',
        priority: 'medium',
        status: 'pending'
      });
      setSelectedStaff([]);
      setOpenDialog(false);
      
      showSnackbar('Task created successfully!');
    } catch (err) {
      showSnackbar('Failed to create task', 'error');
    }
  };

  const handleAssignTask = async (taskId) => {
    try {
      await apiService.assignTask(taskId, selectedStaff);
      
      const updatedTasks = tasks.map(task => 
        task.id === taskId ? { ...task, assignedTo: selectedStaff } : task
      );
      setTasks(updatedTasks);
      setSelectedStaff([]);
      setAssignDialog(false);
      
      showSnackbar('Task assigned successfully!');
    } catch (err) {
      showSnackbar('Failed to assign task', 'error');
    }
  };

  const handleDeleteTask = async (taskId) => {
    try {
      await apiService.deleteTask(taskId);
      setTasks(tasks.filter(task => task.id !== taskId));
      showSnackbar('Task deleted successfully!');
    } catch (err) {
      showSnackbar('Failed to delete task', 'error');
    }
  };

  const handleDeleteActivity = async (activityId) => {
    try {
      await apiService.deleteUserActivity(activityId);
      setUserActivities(userActivities.filter(activity => activity.id !== activityId));
      showSnackbar('Activity deleted successfully!');
    } catch (err) {
      showSnackbar('Failed to delete activity', 'error');
    }
  };

  const openAssignDialog = (task) => {
    setSelectedTask(task);
    setSelectedStaff(task.assignedTo);
    setAssignDialog(true);
  };

  const openViewDialog = (item) => {
    if (item.type === 'user') {
      setSelectedActivity(item);
    } else {
      setSelectedTask(item);
    }
    setViewDialog(true);
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'error';
      case 'medium': return 'warning';
      case 'low': return 'success';
      default: return 'default';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed': return 'success';
      case 'in-progress': return 'warning';
      case 'pending': return 'error';
      case 'reviewed': return 'info';
      default: return 'default';
    }
  };
  
  const getStaffName = (staffId) => {
    const staff = staffList.find(s => s.user_id === staffId);
    return staff ? staff.fullName : 'Unknown';
  };

  const getFileIcon = (fileType) => {
    switch (fileType) {
      case 'pdf': return <PictureAsPdf color="error" />;
      case 'image': return <Image color="primary" />;
      case 'video': return <VideoFile color="secondary" />;
      case 'audio': return <AudioFile color="success" />;
      case 'document': return <Description color="info" />;
      case 'spreadsheet': return <Description color="success" />;
      case 'presentation': return <Description color="warning" />;
      case 'archive': return <InsertDriveFile color="action" />;
      default: return <InsertDriveFile color="action" />;
    }
  };

  const formatDateTime = (dateTimeString) => {
    return new Date(dateTimeString).toLocaleString();
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatTime = (dateTimeString) => {
    return new Date(dateTimeString).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const calculateDuration = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const durationMs = end - start;
    const hours = Math.floor(durationMs / (1000 * 60 * 60));
    const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours}h ${minutes}m`;
  };

  const handleDownloadFile = (file) => {
    alert(`Downloading ${file.name}...\n\nIn a real application, this would download the file from: ${file.url}`);
  };

  const handlePreviewFile = (file) => {
    alert(`Opening preview for ${file.name}...\n\nIn a real application, this would open a preview of the file.`);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  if (loading) {
    return (
      <IonPage>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <Typography variant="h6">Loading...</Typography>
        </Box>
      </IonPage>
    );
  }

  return (
    <IonPage className="pushDown">
      <Box sx={{ 
        flexGrow: 1,
        backgroundColor: '#f8fafc',
        minHeight: '100vh'
      }}>
        {/* Modern App Bar */}
        <AppBar 
          position="static" 
          elevation={0}
          sx={{ 
            backgroundColor: 'white',
            color: 'text.primary',
            borderBottom: '1px solid',
            borderColor: 'divider'
          }}
        >
          <Toolbar>
            <Dashboard sx={{ mr: 2, color: 'primary.main' }} />
            <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 600 }}>
              Admin Task Manager
            </Typography>
            
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
              <IconButton size="large">
                <Badge badgeContent={3} color="error">
                  <Notifications />
                </Badge>
              </IconButton>
              <IconButton size="large">
                <AccountCircle />
              </IconButton>
            </Stack>
          </Toolbar>
        </AppBar>

        <Box sx={{ p: 3 }}>
          {/* Error Alert */}
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {/* Header Section */}
          <Box sx={{ mb: 4 }}>
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              mb: 3
            }}>
              <Box>
                <Typography variant="h4" component="h1" fontWeight="700" gutterBottom>
                  Task Management
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  Manage tasks and view user activity reports
                </Typography>
              </Box>
              
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => setOpenDialog(true)}
                size="large"
                sx={{
                  borderRadius: 3,
                  px: 4,
                  py: 1.5,
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 600,
                  boxShadow: '0 4px 14px 0 rgba(0, 119, 255, 0.2)'
                }}
              >
                New Task
              </Button>
            </Box>

            {/* Stats and Filters */}
            <Card elevation={1} sx={{ borderRadius: 3 }}>
              <CardContent sx={{ p: 3 }}>
                <Grid container spacing={3} alignItems="center">
                  <Grid item xs={12} md={6}>
                    <Stack direction="row" spacing={3}>
                      <Box>
                        <Typography variant="h3" fontWeight="700" color="primary.main">
                          {tasks?.length + userActivities?.length}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Total Items
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant="h3" fontWeight="700" color="success.main">
                          {tasks.filter(t => t.status === 'completed')?.length + 
                           userActivities.filter(a => a.status === 'completed')?.length}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Completed
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant="h3" fontWeight="700" color="warning.main">
                          {tasks.filter(t => t.status === 'in-progress')?.length}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          In Progress
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>
                  
                  <Grid item xs={12} md={6}>
                    <Stack direction="row" spacing={2} justifyContent="flex-end">
                      <TextField
                        size="small"
                        placeholder="Search..."
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ minWidth: 200, borderRadius: 2 }}
                      />
                      <FormControl size="small" sx={{ minWidth: 120 }}>
                        <InputLabel>Type</InputLabel>
                        <Select
                          value={filters.type}
                          label="Type"
                          onChange={(e) => setFilters({ ...filters, type: e.target.value })}
                        >
                          <MenuItem value="all">All Types</MenuItem>
                          <MenuItem value="admin">Admin Tasks</MenuItem>
                          <MenuItem value="user">User Activities</MenuItem>
                        </Select>
                      </FormControl>
                      <TextField
                        size="small"
                        label="Filter by Date"
                        type="date"
                        value={filters.date}
                        onChange={(e) => setFilters({ ...filters, date: e.target.value })}
                        InputLabelProps={{ shrink: true }}
                        sx={{ minWidth: 150, borderRadius: 2 }}
                      />
                      <FormControl size="small" sx={{ minWidth: 120 }}>
                        <InputLabel>Staff</InputLabel>
                        <Select
                          value={filters.staff}
                          label="Staff"
                          onChange={(e) => setFilters({ ...filters, staff: e.target.value })}
                        >
                          <MenuItem value="">All Staff</MenuItem>
                          {staffList.map(staff => (
                            <MenuItem key={staff.user_id} value={staff.user_id}>
                              {staff.fullName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Box>

          {/* Tabs for different views */}
          <Card elevation={3}>
            <CardContent sx={{ p: 0 }}>
              <Tabs 
                value={tabValue} 
                onChange={handleTabChange}
                sx={{ 
                  borderBottom: 1, 
                  borderColor: 'divider',
                  px: 3,
                  pt: 2
                }}
              >
                <Tab 
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Assignment sx={{ mr: 1 }} />
                      Admin Tasks
                      <Chip 
                        label={filteredTasks?.length} 
                        size="small" 
                        sx={{ ml: 1 }}
                        color="primary"
                        variant="outlined"
                      />
                    </Box>
                  } 
                />
                <Tab 
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Description sx={{ mr: 1 }} />
                      User Activities
                      <Chip 
                        label={filteredActivities?.length} 
                        size="small" 
                        sx={{ ml: 1 }}
                        color="secondary"
                        variant="outlined"
                      />
                    </Box>
                  } 
                />
              </Tabs>

              {/* Admin Tasks Table */}
              {tabValue === 0 && (
                <TableContainer component={Paper} elevation={0} sx={{ mt: 2 }}>
                  <Table>
                    <TableHead>
                      <TableRow sx={{ backgroundColor: 'grey.50' }}>
                        <TableCell sx={{ fontWeight: 'bold' }}>Title</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Assigned To</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Due Date</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Priority</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredTasks?.map((task) => (
                        <TableRow key={task.id} hover>
                          <TableCell>
                            <Typography variant="subtitle2" fontWeight="bold">
                              {task.title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {task.description}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                              {task?.assignedTo?.map(staffId => (
                                <Chip
                                  key={staffId}
                                  label={getStaffName(staffId)}
                                  size="small"
                                  variant="outlined"
                                  icon={<Person />}
                                />
                              ))}
                            </Box>
                          </TableCell>
                          <TableCell>{task.dueDate}</TableCell>
                          <TableCell>
                            <Chip
                              label={task.priority}
                              color={getPriorityColor(task.priority)}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={task.status}
                              color={getStatusColor(task.status)}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              <IconButton
                                color="primary"
                                size="small"
                                onClick={() => openViewDialog(task)}
                              >
                                <Visibility />
                              </IconButton>
                              <IconButton
                                color="info"
                                size="small"
                                onClick={() => openAssignDialog(task)}
                              >
                                <Assignment />
                              </IconButton>
                              <IconButton
                                color="warning"
                                size="small"
                                onClick={() => {/* Edit functionality */}}
                              >
                                <Edit />
                              </IconButton>
                              <IconButton
                                color="error"
                                size="small"
                                onClick={() => handleDeleteTask(task.id)}
                              >
                                <Delete />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  {filteredTasks?.length === 0 && (
                    <Alert severity="info" sx={{ m: 2 }}>
                      No admin tasks found matching the current filters.
                    </Alert>
                  )}
                </TableContainer>
              )}

              {/* User Activities Table - Fixed JSX Syntax */}
              {tabValue === 1 && (
                <TableContainer component={Paper} elevation={0} sx={{ mt: 2 }}>
                  <Table>
                    <TableHead>
                      <TableRow sx={{ backgroundColor: 'grey.50' }}>
                        <TableCell sx={{ fontWeight: 'bold' }}>Activity Name</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Staff</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Date Submitted</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Department</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Priority</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredActivities.map((activity) => (
                        <TableRow key={activity.id} hover>
                          <TableCell>
                            <Typography variant="subtitle2" fontWeight="bold">
                              {activity.activityName}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {activity.notes.substring(0, 100)}...
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={activity.staffName}
                              size="small"
                              variant="outlined"
                              icon={<Person />}
                            />
                          </TableCell>
                          <TableCell>{activity.dateSubmitted}</TableCell>
                          <TableCell>
                            <Chip
                              label={activity.department}
                              size="small"
                              variant="outlined"
                            />
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={activity.priority}
                              color={getPriorityColor(activity.priority.toLowerCase())}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={activity.status}
                              color={getStatusColor(activity.status)}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              <IconButton
                                color="primary"
                                size="small"
                                onClick={() => openViewDialog(activity)}
                              >
                                <Visibility />
                              </IconButton>
                              <IconButton
                                color="error"
                                size="small"
                                onClick={() => handleDeleteActivity(activity.id)}
                              >
                                <Delete />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  {filteredActivities?.length === 0 && (
                    <Alert severity="info" sx={{ m: 2 }}>
                      No user activities found matching the current filters.
                    </Alert>
                  )}
                </TableContainer>
              )}
            </CardContent>
          </Card>
        </Box>

        {/* Create Task Dialog */}
        <Dialog 
          open={openDialog} 
          onClose={() => setOpenDialog(false)} 
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: { borderRadius: 3 }
          }}
        >
          <DialogTitle sx={{ 
            backgroundColor: 'primary.main',
            color: 'white',
            py: 3
          }}>
            <Typography variant="h5" component="div" fontWeight="600">
              Create New Task
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={3} sx={{ mt: 1, p: 2 }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Task Title"
                  value={newTask.title}
                  onChange={(e) => setNewTask({ ...newTask, title: e.target.value })}
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Description"
                  multiline
                  rows={3}
                  value={newTask.description}
                  onChange={(e) => setNewTask({ ...newTask, description: e.target.value })}
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Due Date"
                  type="date"
                  value={newTask.dueDate}
                  onChange={(e) => setNewTask({ ...newTask, dueDate: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Priority</InputLabel>
                  <Select
                    value={newTask.priority}
                    label="Priority"
                    onChange={(e) => setNewTask({ ...newTask, priority: e.target.value })}
                    required
                  >
                    <MenuItem value="low">Low</MenuItem>
                    <MenuItem value="medium">Medium</MenuItem>
                    <MenuItem value="high">High</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Assign to Staff</InputLabel>
                  <Select
                    multiple
                    value={selectedStaff}
                    label="Assign to Staff"
                    onChange={(e) => setSelectedStaff(e.target.value)}
                    renderValue={(selected) => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => (
                          <Chip
                            key={value}
                            label={getStaffName(value)}
                            size="small"
                          />
                        ))}
                      </Box>
                    )}
                    required
                  >
                    {staffList.map((staff) => (
                      <MenuItem key={staff.id} value={staff.id}>
                        {staff.name} - {staff.department}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ p: 3 }}>
            <Button 
              onClick={() => setOpenDialog(false)} 
              color="inherit"
              sx={{ borderRadius: 2, textTransform: 'none' }}
            >
              Cancel
            </Button>
            <Button 
              onClick={handleCreateTask} 
              variant="contained"
              sx={{ 
                borderRadius: 2,
                px: 4,
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              Create Task
            </Button>
          </DialogActions>
        </Dialog>

        {/* Assign Task Dialog */}
        <Dialog 
          open={assignDialog} 
          onClose={() => setAssignDialog(false)} 
          maxWidth="sm" 
          fullWidth
          PaperProps={{
            sx: { borderRadius: 3 }
          }}
        >
          <DialogTitle sx={{ 
            backgroundColor: 'info.main',
            color: 'white',
            py: 3
          }}>
            <Typography variant="h6" component="div" fontWeight="600">
              Assign Task: {selectedTask?.title}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <FormControl fullWidth sx={{ mt: 2, p: 2 }}>
              <InputLabel>Assign to Staff</InputLabel>
              <Select
                multiple
                value={selectedStaff}
                label="Assign to Staff"
                onChange={(e) => setSelectedStaff(e.target.value)}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip
                        key={value}
                        label={getStaffName(value)}
                        size="small"
                      />
                    ))}
                  </Box>
                )}
              >
                {staffList.map((staff) => (
                  <MenuItem key={staff.id} value={staff.id}>
                    {staff.name} - {staff.department}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions sx={{ p: 3 }}>
            <Button 
              onClick={() => setAssignDialog(false)}
              sx={{ borderRadius: 2, textTransform: 'none' }}
            >
              Cancel
            </Button>
            <Button 
              onClick={() => handleAssignTask(selectedTask?.id)} 
              variant="contained"
              color="info"
              sx={{ 
                borderRadius: 2,
                px: 4,
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              Assign Task
            </Button>
          </DialogActions>
        </Dialog>

        {/* View Details Dialog */}
        <Dialog 
          open={viewDialog} 
          onClose={() => setViewDialog(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: { 
              borderRadius: 3,
              maxHeight: '90vh',
              overflow: 'hidden'
            }
          }}
        >
          {selectedActivity ? (
            // User Activity View
            <>
              <DialogTitle sx={{ 
                backgroundColor: 'secondary.main',
                color: 'white',
                py: 3
              }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="h4" component="div" fontWeight="600">
                    {selectedActivity.activityName}
                  </Typography>
                  <Chip 
                    label={selectedActivity.status} 
                    color={getStatusColor(selectedActivity.status)}
                    sx={{ color: 'white', backgroundColor: 'rgba(255,255,255,0.2)' }}
                  />
                </Box>
              </DialogTitle>
              
              <DialogContent dividers sx={{ p: 0, overflow: 'auto' }}>
                <Box sx={{ p: 3 }}>
                  {/* Activity Details Section */}
                  <Card elevation={0} sx={{ mb: 3, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                    <CardContent>
                      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                        <Description sx={{ mr: 1 }} /> Activity Details
                      </Typography>
                      
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          <List dense>
                            <ListItem>
                              <ListItemIcon>
                                <Person color="primary" />
                              </ListItemIcon>
                              <ListItemText 
                                primary="Staff" 
                                secondary={selectedActivity.staffName}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemIcon>
                                <Schedule color="primary" />
                              </ListItemIcon>
                              <ListItemText 
                                primary="Duration" 
                                secondary={calculateDuration(selectedActivity.startTime, selectedActivity.endTime)}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemIcon>
                                <AssignmentTurnedIn color="primary" />
                              </ListItemIcon>
                              <ListItemText 
                                primary="Priority" 
                                secondary={
                                  <Chip 
                                    label={selectedActivity.priority} 
                                    color={getPriorityColor(selectedActivity.priority.toLowerCase())}
                                    size="small"
                                  />
                                }
                              />
                            </ListItem>
                          </List>
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                          <List dense>
                            <ListItem>
                              <ListItemIcon>
                                <CalendarToday color="primary" />
                              </ListItemIcon>
                              <ListItemText 
                                primary="Date" 
                                secondary={formatDate(selectedActivity.dateSubmitted)}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemIcon>
                                <AccessTime color="primary" />
                              </ListItemIcon>
                              <ListItemText 
                                primary="Time" 
                                secondary={`${formatTime(selectedActivity.startTime)} - ${formatTime(selectedActivity.endTime)}`}
                              />
                            </ListItem>
                            {selectedActivity.expirationTime && (
                              <ListItem>
                                <ListItemIcon>
                                  <WatchLater color="primary" />
                                </ListItemIcon>
                                <ListItemText 
                                  primary="Expires" 
                                  secondary={formatDateTime(selectedActivity.expirationTime)}
                                />
                              </ListItem>
                            )}
                          </List>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>

                  {/* Notes Section */}
                  <Card elevation={0} sx={{ mb: 3, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                    <CardContent>
                      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                        <Notes sx={{ mr: 1 }} /> Activity Notes
                      </Typography>
                      <Typography variant="body1" sx={{ mt: 2, lineHeight: 1.6 }}>
                        {selectedActivity.notes}
                      </Typography>
                    </CardContent>
                  </Card>

                  {/* Attachments Section */}
                  {selectedActivity.attachments && selectedActivity.attachments?.length > 0 && (
                    <Card elevation={0} sx={{ mb: 3, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                      <CardContent>
                        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                          <AttachFile sx={{ mr: 1 }} /> Attachments ({selectedActivity.attachments?.length})
                        </Typography>
                        <List>
                          {selectedActivity.attachments.map((file) => (
                            <ListItem 
                              key={file.id}
                              sx={{ 
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 2,
                                mb: 1,
                                '&:hover': {
                                  backgroundColor: 'action.hover'
                                }
                              }}
                            >
                              <ListItemIcon>
                                {getFileIcon(file.type)}
                              </ListItemIcon>
                              <ListItemText
                                primary={
                                  <Link 
                                    href={file.url} 
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handlePreviewFile(file);
                                    }}
                                    sx={{ 
                                      cursor: 'pointer',
                                      textDecoration: 'none',
                                      '&:hover': {
                                        textDecoration: 'underline'
                                      }
                                    }}
                                  >
                                    {file.name}
                                  </Link>
                                }
                                secondary={
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 0.5 }}>
                                    <Typography variant="caption" color="text.secondary">
                                      {file.size}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                      Uploaded: {file.uploadDate}
                                    </Typography>
                                  </Box>
                                }
                              />
                              <Stack direction="row" spacing={1}>
                                <IconButton 
                                  size="small" 
                                  onClick={() => handlePreviewFile(file)}
                                  color="primary"
                                  title="Preview"
                                >
                                  <OpenInNew />
                                </IconButton>
                                <IconButton 
                                  size="small" 
                                  onClick={() => handleDownloadFile(file)}
                                  color="primary"
                                  title="Download"
                                >
                                  <Download />
                                </IconButton>
                              </Stack>
                            </ListItem>
                          ))}
                        </List>
                      </CardContent>
                    </Card>
                  )}

                  {/* Tags Section */}
                  {selectedActivity.tags && selectedActivity.tags?.length > 0 && (
                    <Card elevation={0} sx={{ mb: 3, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                      <CardContent>
                        <Typography variant="h6" gutterBottom>
                          Tags
                        </Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                          {selectedActivity.tags.map((tag, index) => (
                            <Chip
                              key={index}
                              label={tag}
                              variant="outlined"
                              color="primary"
                              size="small"
                            />
                          ))}
                        </Box>
                      </CardContent>
                    </Card>
                  )}

                  {/* Review Information */}
                  <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        Review Information
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" color="text.secondary">
                            Reviewed By
                          </Typography>
                          <Typography variant="body1">
                            {selectedActivity.reviewedBy}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" color="text.secondary">
                            Department
                          </Typography>
                          <Typography variant="body1">
                            {selectedActivity.department}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Box>
              </DialogContent>
            </>
          ) : selectedTask ? (
            // Admin Task View
            <>
              <DialogTitle sx={{ 
                backgroundColor: 'primary.main',
                color: 'white',
                py: 3
              }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="h4" component="div" fontWeight="600">
                    {selectedTask.title}
                  </Typography>
                  <Chip 
                    label={selectedTask.status} 
                    color={getStatusColor(selectedTask.status)}
                    sx={{ color: 'white', backgroundColor: 'rgba(255,255,255,0.2)' }}
                  />
                </Box>
              </DialogTitle>
              
              <DialogContent dividers sx={{ p: 0, overflow: 'auto' }}>
                <Box sx={{ p: 3 }}>
                  <Card elevation={0} sx={{ mb: 3, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        Task Details
                      </Typography>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" color="text.secondary">
                            Description
                          </Typography>
                          <Typography variant="body1" sx={{ mt: 1 }}>
                            {selectedTask.description}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" color="text.secondary">
                            Due Date
                          </Typography>
                          <Typography variant="body1" sx={{ mt: 1 }}>
                            {selectedTask.dueDate}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" color="text.secondary">
                            Priority
                          </Typography>
                          <Chip
                            label={selectedTask.priority}
                            color={getPriorityColor(selectedTask.priority)}
                            sx={{ mt: 1 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" color="text.secondary">
                            Created Date
                          </Typography>
                          <Typography variant="body1" sx={{ mt: 1 }}>
                            {selectedTask.createdAt}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>

                  <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        Assigned Staff
                      </Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                        {selectedTask.assignedTo.map(staffId => (
                          <Chip
                            key={staffId}
                            label={getStaffName(staffId)}
                            variant="outlined"
                            icon={<Person />}
                          />
                        ))}
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              </DialogContent>
            </>
          ) : null}
          
          <DialogActions sx={{ p: 3 }}>
            <Button 
              onClick={() => setViewDialog(false)}
              variant="contained" 
              sx={{ 
                borderRadius: 2,
                px: 4,
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Snackbar for notifications */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </IonPage>
  );
};

export default AdminTaskManagement;